module.exports = __webpack_public_path__ + "img/Dan Cates.5e0e1848.png";